var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRemoveTagCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M2.92728 2.1591C2.71515 1.94697 2.37122 1.94697 2.1591 2.1591C1.94697 2.37122 1.94697 2.71515 2.1591 2.92728L5.23184 6.00002L2.15914 9.07272C1.94701 9.28485 1.94701 9.62878 2.15914 9.8409C2.37126 10.053 2.71519 10.053 2.92732 9.8409L6.00002 6.7682L9.07272 9.8409C9.28485 10.053 9.62878 10.053 9.8409 9.8409C10.053 9.62878 10.053 9.28485 9.8409 9.07272L6.7682 6.00002L9.84094 2.92728C10.0531 2.71515 10.0531 2.37122 9.84094 2.1591C9.62882 1.94697 9.28489 1.94697 9.07276 2.1591L6.00002 5.23184L2.92728 2.1591Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveTagCross);
export default __webpack_public_path__ + "static/media/remove-tag-cross.bf210dd9827c6b7c83ab890b36f6d754.svg";
export { ForwardRef as ReactComponent };